export default __webpack_public_path__ + "static/media/background.93cb4051.svg";